import { addDays } from "date-fns";
import { parse, stringify } from "query-string";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { map, Subject } from "rxjs";

import { useQueryParams$ } from "../../common/hooks/useQueryParams$";
import {
  getAttributeList,
  getDateAttribute,
} from "../../common/searchParams.utils";
import AdminAskForActionNotification from "../AdminAskForAction/AdminAskForActionNotification";
import {
  ContainerConfigurate,
  ContainerScroll,
  DivDetailTitle,
} from "../AdminPaymentValidationSidebar/AdminPaymentValidationSidebarStyles";
import {
  InvoiceContainer,
  InvoicesContainer,
  TableHeaderCommon,
} from "../AdminPaymentValidationTable/CommonTable";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import RejectionCommentNotification from "../RejectionComment/RejectionCommentNotification";
import Sidebar from "../Sidebar/Sidebar";
import AdminDocumentValidationSearch from "./AdminDocumentValidationSearch";
import {
  HeaderDocumentDiv,
  HeaderTitleDocumentDiv,
  NotificationjustifyDiv,
} from "./AdminDocumentValidationStyles";
import AdminDocumentValidationTable from "./AdminDocumentValidationTable";

const AdminDocumentValidationResource = () => {
  const params$ = useQueryParams$().pipe(
    map((params: any) => {
      const documentType = params.documentType || "senasa";
      const agent_name = params.agent_name || "";

      const dam = params.dam || {};

      const year = dam.year || new Date().getFullYear().toString();
      const regimen = dam.regimen || "10";
      dam.year = year;
      dam.regimen = regimen;

      const from_date = getDateAttribute(params.from_date);
      const senasa_status_option = getAttributeList(
        params.senasa_status_option,
        ["reviewing"]
      );
      const to_date = getDateAttribute(params.to_date, addDays(new Date(), 5));
      const electronic_mandate_status_option = getAttributeList(
        params.electronic_mandate_status_option
      );
      const third_party_billing_authorization_status_option = getAttributeList(
        params.third_party_billing_authorization_status_option
      );
      const payment_status_option = getAttributeList(
        params.payment_status_option
      );
      const volante_nums = getAttributeList(params.volante_nums);
      return {
        ...params,
        dam,
        documentType,
        agent_name,
        from_date,
        senasa_status_option,
        to_date,
        electronic_mandate_status_option,
        third_party_billing_authorization_status_option,
        volante_nums,
        payment_status_option,
      };
    })
  );
  const [showValidationConfirmation, updateShowValidationConfirmation] =
    useState(false);
  const [titleConfirmation, updateTitleConfirmation] = useState("");
  const [messageConfirmation, updateMessageConfirmation] = useState("");
  const toggleValidationConfirmation = () => {
    updateShowValidationConfirmation((showConfirmation) => !showConfirmation);
  };
  const onTitleConfirmationChange = (title) => {
    updateTitleConfirmation(title);
  };
  const onMessageConfirmationChange = (message) => {
    updateMessageConfirmation(message);
  };
  const history = useHistory();

  const [showSidebarModalNotification, setShowSidebarModalNotification] =
    useState(false);
  return (
    <div>
      <HeaderDocumentDiv>
        <HeaderTitleDocumentDiv>
          VALIDACIÓN DE DOCUMENTOS
        </HeaderTitleDocumentDiv>
        <NotificationButton
          setShowSidebarModalNotification={setShowSidebarModalNotification}
          showSidebarModalNotification={showSidebarModalNotification}
        />
      </HeaderDocumentDiv>
      <AdminDocumentValidationSearch params$={params$} />
      <AdminDocumentValidationTable
        params$={params$}
        onMessageConfirmationChange={onMessageConfirmationChange}
        onTitleConfirmationChange={onTitleConfirmationChange}
        toggleValidationConfirmation={toggleValidationConfirmation}
      />
      {showValidationConfirmation && (
        <ConfirmationModal
          message={messageConfirmation}
          onAccept={() => {
            toggleValidationConfirmation();
            const parsedParams = { ...parse(window.location.search), page: 1 };
            const stringifiedParams = stringify(parsedParams);
            const pathname = history.location.pathname;
            history.push(`${pathname}?${stringifiedParams}`);
          }}
          title={titleConfirmation}
          toggleModal={() => {
            toggleValidationConfirmation();
            const parsedParams = { ...parse(window.location.search), page: 1 };
            const stringifiedParams = stringify(parsedParams);
            const pathname = history.location.pathname;
            history.push(`${pathname}?${stringifiedParams}`);
          }}
        />
      )}
    </div>
  );
};

export default AdminDocumentValidationResource;

const NotificationButton = (props) => {
  const { setShowSidebarModalNotification } = props;

  const destroy$Ref = useRef(new Subject());

  const destroy$: any = destroy$Ref.current;
  useEffect(() => {
    return () => {
      destroy$.next();
      destroy$.complete();
    };
  }, [destroy$]);

  const [showRejectCommentNotification, setShowRejectCommentNotification] =
    useState(false);
  const [showAskForActionNotification, setShowAskForActionNotification] =
    useState(false);

  const toggleShowAskForActionNotification = () => {
    setShowAskForActionNotification(!showAskForActionNotification);
  };
  const toggleShowRejectCommentNotification = () => {
    setShowRejectCommentNotification(!showRejectCommentNotification);
  };
  const [sidebarInfo] = useState<any>({});

  const [
    showModalSuccessErrorNotification,
    setShowModalSuccessErrorNotification,
  ] = useState(false);
  const [
    messageModalSuccessErrorNotification,
    setMessageModalSuccessErrorNotification,
  ] = useState("");
  const [
    titleModalSuccessErrorNotification,
    setTitleModalSuccessErrorNotification,
  ] = useState("");
  const [operationSuccess, setOperationSuccess] = useState(false);

  const history = useHistory();
  const [
    showSidebarModalDetailsNotification,
    setShowSidebarModalDetailsNotification,
  ] = useState(false);
  const gridTemplateColumnsSidebar = "2fr 1fr 1fr 2fr";
  return (
    <NotificationjustifyDiv>
      {showRejectCommentNotification && (
        <RejectionCommentNotification
          toggleModal={() => {
            toggleShowRejectCommentNotification();
          }}
          title="Rechazar documento"
          sidebarInfoData={sidebarInfo}
          setShowModalSuccessErrorNotification={
            setShowModalSuccessErrorNotification
          }
          setMessageModalSuccessErrorNotification={
            setMessageModalSuccessErrorNotification
          }
          setTitleModalSuccessErrorNotification={
            setTitleModalSuccessErrorNotification
          }
          setOperationSuccess={setOperationSuccess}
          toggleSuccessReject={() => {
            toggleShowRejectCommentNotification();
            setShowSidebarModalNotification(false);
          }}
        />
      )}

      {showAskForActionNotification && (
        <AdminAskForActionNotification
          toggleModal={() => {
            toggleShowAskForActionNotification();
          }}
          titleMessage={"Confirmación de Aprobación"}
          bodyMessage={"El documento será aprobado al momento de confirmación."}
          buttonMessage={"Aprobar documento"}
          sidebarInfoData={sidebarInfo}
          setShowModalSuccessErrorNotification={
            setShowModalSuccessErrorNotification
          }
          setMessageModalSuccessErrorNotification={
            setMessageModalSuccessErrorNotification
          }
          setTitleModalSuccessErrorNotification={
            setTitleModalSuccessErrorNotification
          }
          setOperationSuccess={setOperationSuccess}
          toggleSucces={() => {
            toggleShowAskForActionNotification();
            setShowSidebarModalNotification(false);
          }}
        />
      )}
      {showModalSuccessErrorNotification &&
        messageModalSuccessErrorNotification && (
          <ConfirmationModal
            message={messageModalSuccessErrorNotification}
            onAccept={() => {
              if (operationSuccess) {
                const parsedParams = {
                  ...parse(window.location.search),
                  page: 1,
                };
                const stringifiedParams = stringify(parsedParams);
                const pathname = history.location.pathname;
                history.push(`${pathname}?${stringifiedParams}`);
                setOperationSuccess(false);
              }
              setMessageModalSuccessErrorNotification("");
              setShowModalSuccessErrorNotification(false);
            }}
            title={titleModalSuccessErrorNotification}
            toggleModal={() => {
              setMessageModalSuccessErrorNotification("");
              setShowModalSuccessErrorNotification(false);
            }}
          />
        )}

      {showSidebarModalDetailsNotification && (
        <Sidebar
          onOutsideClick={() => {
            setShowSidebarModalDetailsNotification(false);
          }}
        >
          <ContainerScroll>
            <ContainerConfigurate width="84.2rem">
              <DivDetailTitle fontSize="2rem">
                Detalles del documento
              </DivDetailTitle>
              <InvoicesContainer
                gridTemplateColumns={gridTemplateColumnsSidebar}
              >
                <TableHeaderCommon className="item-container">
                  <div
                    className="main-info-header"
                    style={{ marginLeft: "2rem" }}
                  >
                    {"DAM"}
                  </div>
                  <div>{"AWB"}</div>
                  <div>{"HAWB"}</div>
                  <div>{"VOLANTE"}</div>
                </TableHeaderCommon>
                <div
                  style={{ overflowY: "scroll", maxHeight: "21.1vh" }}
                  className="scroll"
                >
                  {sidebarInfo &&
                    sidebarInfo.sidebar_details.volantes.map((elem) => {
                      return (
                        <div
                          key={elem.volante_num}
                          style={{ cursor: "pointer" }}
                        >
                          <InvoiceContainer
                            className="item-container"
                            height="7rem"
                          >
                            <div className="attribute main-info-header">
                              <div className="titles">{"DAM"}</div>
                              <div className="main-info-header">
                                <div className="left-align">
                                  {sidebarInfo.sidebar_details.dam_num}
                                </div>
                              </div>
                            </div>
                            <div className="attribute">
                              <div className="titles">{"AWB"}</div>
                              <div>{elem.master_air_waybill}</div>
                            </div>
                            <div className="attribute">
                              <div className="titles">{"HAWB"}</div>
                              <div className="left-align">
                                {elem.house_air_waybill}
                              </div>
                            </div>
                            <div className="attribute">
                              <div className="titles">{"VOLANTE"}</div>
                              <div>{elem.volante_num}</div>
                            </div>
                          </InvoiceContainer>
                        </div>
                      );
                    })}
                </div>
              </InvoicesContainer>
            </ContainerConfigurate>
          </ContainerScroll>
        </Sidebar>
      )}
    </NotificationjustifyDiv>
  );
};
